import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  IconButton,
} from "@mui/material";
import { FaTimes } from "react-icons/fa";
import { updateMeasureStatus } from "../../../../../server/server";
import { notif } from "../../../../utils/util";

interface RealisationStatusModalProps {
  open: boolean;
  onClose: () => void;
  item: any;
}

const translations = [
  { id: 0, name: "Нереализовано" },
  { id: 1, name: "Делимично реализовано" },
  { id: 2, name: "Реализовано" },
];

const RealisationStatusModal: React.FC<RealisationStatusModalProps> = ({
  open,
  onClose,
  item,
}) => {
  const [selectedOption, setSelectedOption] = useState<number>(0);
  const [comment, setComment] = useState<string>("");
  const [isSaving, setIsSaving] = useState<boolean>(false);

  useEffect(() => {
    if (open && item) {
      setSelectedOption(
        typeof item?.status === "number"
          ? item.statusCode
          : Number(item?.statusCode ?? 0)
      );
      setComment(item?.measureComment ?? "");
    }
  }, [open, item]);

  const handleSave = async () => {
    if (!item?.id) return;
    setIsSaving(true);
    try {
      const resp = await updateMeasureStatus({
        id: item.measureId,
        status: selectedOption,
        comment: comment ?? "",
        reportId: item.id,
      });
      if (resp?.status === 201) {
        notif("Статус успешно сачуван", "success");
        onClose();
        return;
      }
      notif("Грешка при чувању статуса", "error");
    } catch (err) {
      console.error(err);
      notif("Грешка при чувању статуса", "error");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableEnforceFocus
      disableAutoFocus
    >
      <DialogTitle>
        <div className="flex justify-between items-center">
          <span className="text-[#04438b] text-2xl font-bold">
            Измена статуса мере - {item?.measureName ?? item?.title ?? ""}
          </span>
        </div>
      </DialogTitle>

      <DialogContent>
        <div className="flex flex-col gap-4 pt-2">
          <div className="flex items-center gap-6">
            <FormControl size="small" sx={{ minWidth: 300 }}>
              <InputLabel id="realisation-status-label">
                Статус испуњености
              </InputLabel>
              <Select
                labelId="realisation-status-label"
                value={selectedOption}
                label="Статус испуњености"
                onChange={(e) => setSelectedOption(Number(e.target.value))}
              >
                {translations.map((t) => (
                  <MenuItem key={t.id} value={t.id}>
                    {t.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div className="flex flex-col">
            <label className="text-sm text-gray-600 mb-1">
              Образложење статуса
            </label>
            <TextField
              multiline
              rows={4}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              variant="outlined"
              fullWidth
              size="small"
              inputProps={{
                style: {
                  whiteSpace: "pre-wrap",
                  overflowWrap: "break-word",
                },
              }}
              sx={{
                "& .MuiInputBase-input": {
                  overflowX: "hidden",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                },
                "& textarea": {
                  resize: "vertical",
                },
              }}
            />
          </div>
        </div>
      </DialogContent>

      <DialogActions>
        <div className="flex flex-row justify-between items-center w-full mt-6 p-6">
          <div
            className="border border-[#81848f] hover:bg-[#81848f] hover:text-white cursor-pointer flex items-center justify-center border-redError text-redError text-base font-semibold rounded-lg w-[250px] h-[55px]"
            onClick={() => onClose()}
          >
            Oткажи
          </div>
          <div
            className="bg-darkBlue cursor-pointer flex items-center justify-center text-white hover:opacity-90 text-base font-semibold rounded-lg w-[250px] h-[55px]"
            onClick={() => handleSave()}
          >
            Сачувај
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default RealisationStatusModal;
